import React from "react";

import { Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { useDispatch } from "react-redux";
import { setTableCheckTrueFetch } from "../../features/action/fetchStorage";


const StyledTableCell = styled(TableCell)(({ theme }) => ({

    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== '$checked',
})(({ theme, $checked }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  ...( $checked && {
    textDecoration: 'line-through',
    opacity: 0.5,
  }),
}));
  

const Tables = ({i}) => {
  const dispatch = useDispatch();
  const handleCheckChange = (orderSH, rowIndex) => {
    dispatch(setTableCheckTrueFetch(orderSH, rowIndex));
  };

  return (
    <div>
        <div className="pb-5 px-6 shadow-lg w-[97%] m-auto rounded-b-[8px]">
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      
                      <TableCell align="right">'כמות'</TableCell>
                      <TableCell align="right">משטח</TableCell>
                      <TableCell align="right">תאור מוצר</TableCell>
                      <TableCell align="right">מק"ט</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {i.table.map((row, key) => (
                      <StyledTableRow
                        key={key}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          textDecoration: row.check ? 'line-through' : 'none',
                          opacity: row.check ? 0.5 : 1,
                          backgroundColor: row.check ? '#f5f5f5' : 'inherit'
                        }}
                      >
                        <StyledTableCell align="right">{row.quantity}</StyledTableCell>
                        <StyledTableCell align="right">{row.location}</StyledTableCell>
                        <StyledTableCell align="right">{row.product}</StyledTableCell>
                        <StyledTableCell align="right">{row.code}</StyledTableCell>
                        <StyledTableCell align="right">
                          <input
                            type="checkbox"
                            checked={row.check}
                            onChange={() => handleCheckChange(i.orderSH, key)}
                            style={{
                              width: '20px',
                              height: '20px',
                              cursor: 'pointer'
                            }}
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              </div>
          </div>
  );
};

export default Tables;
